import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { Box } from '@material-ui/core'

import PaymentMethodPriceTablesTableRow from '../PaymentMethodPriceTablesTableRow'
import PerfectScrollbar from 'react-perfect-scrollbar'

import PropTypes from 'prop-types'

const PaymentMethodPriceTablesTable = ({ paymentMethodPriceTables }) => {
  return (
    <Box width="100%">
      <PerfectScrollbar>
        <Table
          size="medium"
          noWrap
          emptyMessage="Nenhuma tabela de preço encontrado"
        >
          <TableHead>
            <TableRow>
              <TableCell width="40%" align="left">
                Condição
              </TableCell>
              <TableCell width="30%" align="left">
                Taxa
              </TableCell>
              <TableCell width="30%" align="left">
                Parcela
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentMethodPriceTables
              ?.sort((a, b) => a.split - b.split)
              .map((paymentMethodPriceTable) => (
                <PaymentMethodPriceTablesTableRow
                  paymentMethodPriceTable={paymentMethodPriceTable}
                  key={paymentMethodPriceTable.id}
                />
              ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Box>
  )
}

PaymentMethodPriceTablesTable.propTypes = {
  paymentMethodPriceTables: PropTypes.arrayOf(PropTypes.object),
}

export default PaymentMethodPriceTablesTable
